"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsightDrillConfigList = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var InsightDrillConfigItem_1 = tslib_1.__importDefault(require("./InsightDrillConfigItem"));
var useDrillTargetTypeItems_1 = require("./useDrillTargetTypeItems");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
exports.InsightDrillConfigList = function (props) {
    var _a = props.drillConfigItems, drillConfigItems = _a === void 0 ? [] : _a, onDelete = props.onDelete, onSetup = props.onSetup, onIncompleteChange = props.onIncompleteChange;
    var enabledDrillTargetTypeItems = useDrillTargetTypeItems_1.useDrillTargetTypeItems();
    var shouldScrollToContainer = function (item, isLast) {
        return !item.complete && isLast;
    };
    var isLast = function (index) {
        return index === drillConfigItems.length - 1;
    };
    return (react_1.default.createElement("div", { className: "s-drill-config-list" }, drillConfigItems.map(function (item, index) {
        var shouldScroll = shouldScrollToContainer(item, isLast(index));
        return (react_1.default.createElement(sdk_ui_kit_1.ScrollableItem, { scrollIntoView: shouldScroll, key: item.localIdentifier + item.drillTargetType },
            react_1.default.createElement(InsightDrillConfigItem_1.default, { item: item, key: item.localIdentifier + item.drillTargetType, onDelete: onDelete, onSetup: onSetup, onIncompleteChange: onIncompleteChange, enabledDrillTargetTypeItems: enabledDrillTargetTypeItems })));
    })));
};
//# sourceMappingURL=InsightDrillConfigList.js.map